'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import CourseHelpDialog from './CourseHelpDialog';
interface HelpButtonProps {
  courseId?: string;
  locale?: string;
}
function HelpButton(t0) {
  const $ = _c(10);
  const {
    courseId: t1,
    locale: t2
  } = t0;
  const courseId = t1 === undefined ? "1" : t1;
  const locale = t2 === undefined ? "de" : t2;
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  let t3;
  let t4;
  if ($[0] !== isHelpOpen) {
    t3 = () => {
      if (isHelpOpen) {
        document.body.classList.add("help-modal-open");
      } else {
        document.body.classList.remove("help-modal-open");
      }
      return _temp;
    };
    t4 = [isHelpOpen];
    $[0] = isHelpOpen;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsHelpOpen(true);
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <button onClick={t5} className="inline-flex items-center gap-1 sm:gap-2 rounded-md bg-primary/10 p-2.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium text-primary hover:bg-primary/20 transition-colors" title="Hilfe"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 sm:w-4 sm:h-4 flex-shrink-0"><circle cx="12" cy="12" r="9" /><path d="M9.09 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg><span className="hidden sm:inline">Hilfe</span></button>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsHelpOpen(false);
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== courseId || $[7] !== isHelpOpen || $[8] !== locale) {
    t8 = <>{t6}<CourseHelpDialog isOpen={isHelpOpen} onClose={t7} courseId={courseId} locale={locale} /></>;
    $[6] = courseId;
    $[7] = isHelpOpen;
    $[8] = locale;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}
function _temp() {
  document.body.classList.remove("help-modal-open");
}
export default HelpButton;